import styled from "styled-components";

import { ContainerComponent } from "../../ui";

export const Wrapper = styled("section")(({ theme, variant }) => ({
  height: variant === "full" ? 700 : "auto",
  background:
    variant === "full"
      ? `linear-gradient(180deg, ${theme.palette.searchOverlay} 0%, ${theme.palette.searchOverlayMid} 40%, ${theme.palette.searchOverlayLight} 100%),
       url(/images/background.png)`
      : `linear-gradient(180deg, ${theme.palette.searchBg} 0%, ${theme.palette.searchBgMid} 40%, ${theme.palette.searchBgLight} 100%)`,
  backgroundColor: variant === "full" ? "" : theme.palette.searchBgMid,
  backgroundSize: "cover",
  backgroundPosition: "center center",
  backgroundRepeat: "no-repeat",
  marginBottom: 0,

  [theme.down("xl")]: {
    height: variant === "full" ? 500 : "auto",
  },

  [theme.down("sm")]: {
    height: "auto",
  },
}));

export const WrapperContainer = styled(ContainerComponent)(({ theme }) => ({
  height: "100%",
  position: "relative",

  [theme.down("sm")]: {
    ...theme.paddings(20, 0),
  },
}));
